import { Icons, MenuItem } from '@silverfort/sf-components';

import { isFeatureActive } from '@silverfort-nodelibs/common/utils/common';
import { FEATURE_FLAGS_NAMES, ROLES, TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';

import useFeature from '../../../components/SystemSettings/hooks/featureFlags/useFeature';
import { useSassRestrictions } from '../../../context/contexts/SassRestrictionsContext';
import { LogicalItemsTypes } from '../../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { isUserPermitted } from '../../../TowerMenu/TowerMenuUtils';

export const AIAssistantLogicalMenuItems = ({ userData, getTowerMenuHref, ...props }: LogicalItemsTypes) => {
    const { restrictedSaasSupportMode } = useSassRestrictions();
    const aiAssistantFlag = useFeature(FEATURE_FLAGS_NAMES.AIAssistant);
    const hasPermission = isUserPermitted(userData, 'aiAssistant', ROLES.VIEWER.value);

    if (!isFeatureActive(aiAssistantFlag)) {
        return null;
    }

    return (
        <MenuItem
            id={TOWER_MENU_ITEMS.AI_ASSISTANT}
            ItemIcon={Icons.Lightning}
            title="AI Assistant"
            href={getTowerMenuHref(TOWER_MENU_ITEMS.AI_ASSISTANT)}
            disabled={restrictedSaasSupportMode || !hasPermission}
            earlyAvailability={true}
            {...props}
        />
    );
};
